<template>
  <section class="main card plans section--full-width">
    <template v-if="!ui.hasSaved">
      <header class="card-header">
        <h2>
          Assinatura Plano
          {{ ui.isMarketPlace ? 'MARKETPLACE' : 'PREMIUM' }}
        </h2>
      </header>

      <article
        :class="{ 'cursor-not-allowed': ui.isLoading }"
        class="checkout"
      >
        <div
          :class="{ 'pointer-events-none': ui.isLoading }"
          class="checkout__col"
        >
          <credit-card v-model="card" />

          <div v-if="isApmMember !== null" class="mt-5">
            <coupon v-if="!isApmMember" @coupon-activated="ui.hasCoupon = true" />
            <div v-else>

              <p class="lead pt-5"><strong>Parabéns!</strong> Devido a sua associação com a <strong>APM - Associação Paulista de Medicina</strong>, você acaba de ganhar um desconto especial!</p>
            </div>
          </div>
          <div v-else>carregando...</div>
        </div>

        <div class="checkout__col">
          <features v-if="!isApmMember" :has-coupon.sync="ui.hasCoupon"/>
          <features v-else :apmMember="true" :discountApm.sync="apmMemberDiscount" />

          <div class="flex items-start justify-start w-full py-3">
            <button
              :disabled="!isValid || ui.isLoading"
              class="btn btn-primary w-full uppercase !py-5 !flex !items-center !justify-center"
              @click="doCheckout"
            >
              Confirmar assinatura
            </button>
          </div>
        </div>
      </article>
    </template>

    <template v-if="ui.hasSaved">
      <success-msg />
    </template>

    <action-modal
      v-if="actionModal.show"
      :active.sync="actionModal.show"
      :css="actionModal.css"
      :body="actionModal.body"
      :size="actionModal.size"
      :btn="actionModal.btn"
      :action="actionModal.action"
      @close="actionModal.show = false"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import VueJwtDecode from 'vue-jwt-decode'
import checkoutCreditCard from './checkoutCreditCard.vue'
import checkoutCoupon from './checkoutCoupon.vue'
import checkoutFeatures from './checkoutFeatures.vue'
import checkoutSuccess from './checkoutSuccess.vue'
import actionModal from '@/components/modals/action'
import EventBus from '@/globals/eventBus'

export default {
  name: 'DoctorPlansCheckout',

  components: {
    creditCard: checkoutCreditCard,
    coupon: checkoutCoupon,
    features: checkoutFeatures,
    successMsg: checkoutSuccess,
    actionModal
  },

  data () {
    return {
      apmMemberDiscount: null,
      ui: {
        isLoading: false,
        hasSaved: false,
        hasCoupon: false,
        isMarketPlace: false
      },
      cpf: null,
      isApmMember: null,
      checkingApmMember: true,
      card: null,
      actionModal: {
        show: false,
        size: 'md4',
        css: `
          color: white !important;
          background: url(/static/img/integracao-health-place.png);
          background-size: cover;
          background-position: right center;
          width: 600px;
          max-width: 600px;
          `,
        btn: {
          class: 'btn-purple btn-md',
          text: 'Confirmar'
        },
        body: `
          <div style="width: 400px;">
            <h2 style="color: white; margin: -1.1rem 0 1rem 0; font-weight: 700">
              Parabéns!
            </h2>

            <p style="font-weight: 600; margin: 0 2rem 0 0; hyphens: auto; width: 60%;">
              Ao disponibilizar ao menos 5 horários para o Marketplace Dr. Conecta,
              você se tornou elegível ao desconto de <strong>50% da mensalidade MARKETPLACE.</strong>
              <br><br>
              Agora é só finalizar sua compra para aproveitar todos os recursos da nossa plataforma.
            </p>
          </div>
        `,
        action: function () {
          this.close()
        }
      }
    }
  },
  watch: {
    cpf: {
      handler (newValue) {
        if (!newValue) return
        this.getDoctorIsApmMember(newValue)
      }
    }
  },
  computed: {
    ...mapGetters({ plan: 'getPlan' }),

    isValid () {
      if (this.card && this.card.id === 0) {
        return this.card.isValid
      }

      if (this.card && this.card.id !== 0) {
        return true
      }

      return false
    }
  },

  created () {
    this.getCpfDoctor()

    this.fn_HIDE_PROGRESS()

    // if (this.plan.isPremium) {
    //   this.$router.push({ name: 'DoctorPlans' })
    // }

    this.$nextTick(() => {
      document.querySelector('section.plans').scrollIntoView({ behaviour: 'smooth' })
    })

    this.checkHealthplaceRequirements()
      .then((status) => {
        this.ui.isMarketPlace = status

        if (!status) {
          this.showDiscountAlert()
          return
        }

        this.showDiscountConfirm()
      })

    this.$nextTick(() => {
      window.scrollTo(0, 0)
    })
  },

  methods: {
    doCheckout () {
      this.ui.isLoading = true
      this.fn_SHOW_PROGRESS()

      this.saveNewCard()
        .then(({ id }) => {
          const data = {
            'doctor_subscription_plan': {
              subscriptionPlan: this.plan.premiumId,
              creditCard: id
            }
          }

          EventBus.$emit('reload-credit-card-list')
          Object.keys(this.card).forEach((key) => {
            this.$set(this.card, key, null)
          })

          return data
        })
        .then((data) => this.confirmPayment(data))
        .then(() => this.refreshToken())
        .then(() => {
          this.ui.hasSaved = true
        })
        .catch((err) => this.fn_HANDLE_ERROR(err))
        .finally(() => {
          this.ui.isLoading = false
          this.fn_HIDE_PROGRESS()
        })
    },

    saveNewCard () {
      if (this.card.id === 0) {
        const data = { ...this.card }
        delete data.isValid
        delete data.id
        data.isDefault = 1
        data.expirationDate = data.expirationDate.replace(/\D/, '')

        return new Promise((resolve, reject) => {
          this.$http
            .post(
              '/user/credit_card',
              { 'credit_card': data },
              this.$store.getters.getAuthHeader
            )
            .then((res) => resolve(res.data))
            .catch((err) => reject(err))
        })
      }

      return Promise.resolve({ id: this.card.id })
    },

    getCpfDoctor () {
      return new Promise((resolve, reject) => {
        this.$http
          .get(
            '/doctor',
            this.$store.getters.getAuthHeader
          )
          .then((res) => {
            this.cpf = res.data.user.cpf
          })
          .catch((err) => {
            console.trace(err)
          })
      })
    },

    getDoctorIsApmMember (cpf) {
      return new Promise((resolve, reject) => {
        function addPoints (arg) {
          return arg.substring(0, 3) + '.' + arg.substring(3, 6) + '.' + arg.substring(6, 9) + '-' + arg.substring(9)
        }
        this.$http
          .get(
            // `/doctor/apm/check_doctor?cpf=${cpf}`,
            `/doctor/apm/check_doctor?cpf=${addPoints(cpf)}`,
            this.$store.getters.getAuthHeader
          )
          .then((res) => {
            this.isApmMember = res.data.status
            this.apmMemberDiscount = res.data.discount
            this.checkingApmMember = true
          })
          .catch((err) => {
            console.trace(err)
          })
      })
    },

    confirmPayment (data = {}) {
      const url = '/doctor/doctor_subscription_plan'

      return new Promise((resolve, reject) => {
        this.$http
          .post(url, data, this.$store.getters.getAuthHeader)
          .then(resolve)
          .catch((err) => reject(err))
      })
    },

    refreshToken () {
      return new Promise((resolve, reject) => {
        this.$http
          .post(
            '/api/token/refresh',
            { 'refresh_token': this.$store.getters.getRefreshToken },
            this.$store.getters.getAuthHeader
          )
          .then((res) => {
            this.$store.dispatch('setAuth', res.data)

            const roles = VueJwtDecode.decode(res.data.token).roles
            const isPro = roles.some((role) => /doctor_pro/gi.test(role))
            const isPremium = roles.some((role) => /doctor_premium/gi.test(role)) ||
              roles.some((role) => /doctor_facilities/gi.test(role))
            this.$store.dispatch('setPlan', { isPro, isPremium })

            resolve()
          })
          .catch((err) => reject(err))
      })
    },

    checkHealthplaceRequirements () {
      const url = '/doctor/doctor_health_place/has_agenda_available'

      return new Promise((resolve) => {
        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then((res) => {
            resolve(Boolean(res.data))
          })
          .catch(() => resolve(false))
      })
    },

    showDiscountAlert () {
      const msg = `Quer ganhar 50% de desconto no plano PREMIUM?
        Faça a integração com o Marketplace Dr. Conecta e reserve
        ao menos <strong>5 horários</strong> da sua agenda para
        ativar essa oferta.`

      this.$store.dispatch('setModalConfirm', {
        title: 'Oferta',
        body: msg,
        confirmText: 'Ganhar 50% de desconto',
        cancelText: 'Cancelar',
        beforeClose: (v) => {
          if (v) {
            this.$store.dispatch('setPlan', { isCTA: true })
            this.$router.push({ name: 'DoctorAppIntegrationPrices' })
          }
          this.$store.dispatch('setModalConfirm')
        },
        size: 'md1',
        active: true
      })
    },

    showDiscountConfirm () {
      this.actionModal.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '$vars';

.checkout {
  @apply flex flex-row flex-wrap items-start justify-between;
  padding: 0 30px 30px 30px;

  &__col {
    &:first-of-type {
      flex: 0 0 65%;
    }

    &:last-of-type {
      align-self: stretch;
      flex: 0 0 calc(35% - 1rem);
    }
  }
}
</style>
